import { VisualizationTable } from './visualizationTypes';

type ChatVisualizationTableProps = {
  visualization: VisualizationTable;
  embedded?: boolean;
};

export default function ChatVisualizationTable({
  visualization,
  embedded = false,
}: ChatVisualizationTableProps) {
  const { title, columns, data } = visualization;

  const table = (
    <div className="overflow-x-auto">
      <table className="min-w-full text-left text-xs">
        <thead className="bg-taupe-100 text-black-700">
          <tr>
            {columns.map((column) => (
              <th key={column} className="px-3 py-2 font-semibold whitespace-nowrap">
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, rowIndex) => (
            <tr
              key={`${rowIndex}-${String(row[columns[0]] ?? rowIndex)}`}
              className="border-t border-taupe-200 text-black-800"
            >
              {columns.map((column) => (
                <td key={`${rowIndex}-${column}`} className="px-3 py-2 whitespace-nowrap">
                  {row[column] ?? '—'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  if (embedded) {
    return table;
  }

  return (
    <div className="mt-2 overflow-hidden rounded-md border border-taupe-300 bg-white">
      {title && (
        <div className="border-b border-taupe-200 bg-taupe-50 px-3 py-2 text-xs font-semibold text-black-800">
          {title}
        </div>
      )}
      {table}
    </div>
  );
}
